<div class="wcard" *ngIf="view$ | async as v" [style.display]="bare ? 'none' : null" [class.flush]="flush" (click)="onCardClick(v)" [class.clickable]="drillable && v.kind === 'data'">
  <div class="whead" *ngIf="!flush">
    <div>
      <h3>{{ title | translate }}</h3>
      <div class="wsub" *ngIf="subtitle">{{ subtitle | translate }}</div>
    </div>
    <span class="stale" *ngIf="v.kind === 'data' && v.result.stale">{{ 'dashboard.state.recalculating' | translate }}</span>
  </div>

  <ng-container [ngSwitch]="v.kind">
    <div *ngSwitchCase="'loading'" class="wskel"><i></i><i></i><i></i></div>
    <ng-container *ngSwitchCase="'data'"><ng-content></ng-content></ng-container>
    <div *ngSwitchCase="'empty'" class="wstate">
      <p class="t">{{ emptyTitleKey | translate }}</p>
      <p class="s">{{ emptySubtitleKey | translate }}</p>
      <button *ngIf="emptyActionKey" nbButton status="primary" size="small" (click)="emptyAction.emit(); $event.stopPropagation()">{{ emptyActionKey | translate }}</button>
    </div>
    <div *ngSwitchCase="'error'" class="wstate">
      <p class="t">{{ 'dashboard.state.error_title' | translate }}</p>
      <p class="s">{{ 'dashboard.state.error_sub' | translate }}</p>
      <button nbButton ghost size="small" (click)="retry(); $event.stopPropagation()">{{ 'dashboard.state.retry' | translate }}</button>
    </div>
    <div *ngSwitchCase="'locked'" class="wstate">
      <p class="t">{{ 'dashboard.state.locked_title' | translate }}</p>
      <p class="s">{{ 'dashboard.state.locked_sub' | translate }}</p>
    </div>
  </ng-container>
</div>
